import { MarkdownViewer } from '@ardoq/markdown';
import styled from 'styled-components';
import { s32 } from '@ardoq/design-tokens';

const Container = styled.div`
  padding: ${s32} ${s32} 0;
`;

type ResponseFeedbackModalProps = {
  markdown: string;
};

export function ResponseFeedbackModal({
  markdown,
}: ResponseFeedbackModalProps) {
  return (
    <Container>
      <MarkdownViewer content={markdown} sanitationLevel="permissive" />
    </Container>
  );
}
